import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';

import { muiTheme } from './muiTheme.js';
import { NucleusTheme } from './theme.js';
import { mergeThemes } from './mergeThemes.js';

interface ThemeProviderProps {
  /**
   * The components to receive the theme object.
   */
  children: React.ReactNode;

  /**
   * The theme object to apply to downstream components.
   */
  theme?: NucleusTheme;
}

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  const mergedTheme = !!theme ? mergeThemes(muiTheme, theme) : muiTheme;

  return <MuiThemeProvider theme={mergedTheme}>{children}</MuiThemeProvider>;
};

ThemeProvider.displayName = 'ThemeProvider';

export default ThemeProvider;
